import React from 'react';
import { ZapIcon, CalendarIcon, ClockIcon } from 'lucide-react';
export function GetStarted() {
  return <section className="w-full py-16 px-6 md:px-12" data-id="element-267">
      <div className="max-w-6xl mx-auto" data-id="element-268">
        <h2 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-269">
          Get Started in Seconds
        </h2>
        <p className="text-lg text-[#F5F7FA] text-opacity-80 text-center mb-16 max-w-2xl mx-auto" data-id="element-270">
          From setup to your first meeting brief in less than a minute
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-271">
          <div className="bg-white bg-opacity-5 rounded-xl p-8" data-id="element-272">
            <div className="w-12 h-12 bg-[#3B82F6] bg-opacity-20 rounded-lg flex items-center justify-center mb-6" data-id="element-273">
              <ZapIcon className="h-6 w-6 text-[#3B82F6]" data-id="element-274" />
            </div>
            <h3 className="text-xl font-semibold mb-3" data-id="element-275">5 Seconds to Connect</h3>
            <p className="text-[#F5F7FA] text-opacity-80" data-id="element-276">
              Connect your Gmail securely with one click using Google OAuth — no
              setup, no installs, no fluff.
            </p>
          </div>
          <div className="bg-white bg-opacity-5 rounded-xl p-8" data-id="element-277">
            <div className="w-12 h-12 bg-[#3B82F6] bg-opacity-20 rounded-lg flex items-center justify-center mb-6" data-id="element-278">
              <CalendarIcon className="h-6 w-6 text-[#3B82F6]" data-id="element-279" />
            </div>
            <h3 className="text-xl font-semibold mb-3" data-id="element-280">
              30 Seconds to Prepare
            </h3>
            <p className="text-[#F5F7FA] text-opacity-80" data-id="element-281">
              AI scans your inbox, finds relevant threads, and delivers a
              digestible, actionable meeting brief.
            </p>
          </div>
          <div className="bg-white bg-opacity-5 rounded-xl p-8" data-id="element-282">
            <div className="w-12 h-12 bg-[#3B82F6] bg-opacity-20 rounded-lg flex items-center justify-center mb-6" data-id="element-283">
              <ClockIcon className="h-6 w-6 text-[#3B82F6]" data-id="element-284" />
            </div>
            <h3 className="text-xl font-semibold mb-3" data-id="element-285">0 Minutes Wasted</h3>
            <p className="text-[#F5F7FA] text-opacity-80" data-id="element-286">
              No more last-minute scrambling, copy-pasting, or searching through
              threads — just show up ready.
            </p>
          </div>
        </div>
      </div>
    </section>;
}